/**
 * Thai strings. **Unreviewed by a native speaker — have an operator read these before shipping.**
 * The two doing the most work are `ปิดยอด` for sign-off and `เทียบไม่ได้` for not-comparable.
 *
 * Keys match `en.ts` exactly; a missing key falls back to English rather than rendering the key.
 */
import type { MessageSchema } from "./en";

const th = {
  app: {
    renderError:
      "เกิดข้อผิดพลาดขณะแสดงหน้าจอนี้ กรุณาโหลดหน้าใหม่ หากเกิดซ้ำ แจ้งฝ่าย IT ว่ากำลังทำอะไรอยู่ตอนที่เกิดปัญหา",
  },
  shared: {
    confirmIrreversible: {
      typeToConfirm: "พิมพ์ {phrase} เพื่อดำเนินการต่อ",
    },
  },
  intent: {
    settled: "เรียบร้อย",
    "in-flight": "กำลังดำเนินการ",
    "needs-human": "ต้องดำเนินการ",
    "not-comparable": "เทียบไม่ได้",
  },
  op: {
    float_topup: "เติมเงินทอน",
    smart_empty: "ถ่ายเงินเข้าลิ้นชัก",
    closeout: "ปิดตู้",
    reconcile: "กระทบยอด",
  },
  money: {
    declared: "สำแดง",
    toFloat: "เข้าช่องทอน",
    toCashbox: "เข้าลิ้นชักเก็บเงิน",
    short: "ขาด",
    over: "เกิน",
  },
  queue: {
    andMore: "และอีก {n} รายการ",
  },
  signoff: {
    title: "ปิดยอด{date}",
    businessDay: "วันทำการ",
    verdict: "ผลการกระทบยอด",
    cashAccepted: "ยอดเงินสดที่รับ",
    irreversible: "ไม่มีช่องทางย้อนกลับ หากมีรายการเข้ามาภายหลัง ระบบจะแสดงส่วนที่เปลี่ยนแปลง",
    confirm: "ปิดยอด {date}",
    cancel: "ยกเลิก",
    notOver: "ยังไม่สิ้นสุดวันทำการ ปิดยอดได้หลัง {time}",
    heading: "ปิดยอดวันทำการ",
    needBreakGlass: "เข้าสู่คาสิโนจากเมนูการดูแลระบบเพื่อปิดยอดวันทำการ",
    onlyManager: "เฉพาะผู้จัดการเท่านั้นที่ปิดยอดวันทำการได้",
    dateFieldCalendar: "ช่องนี้อาจแสดงปีเป็นพุทธศักราช (พ.ศ.) — วันที่ที่ใช้ยืนยันด้านล่างเป็นปีคริสต์ศักราช (ค.ศ.) เสมอ",
    noteLabel: "หมายเหตุ (ถ้ามี)",
    notePlaceholder: "เช่น กะดึก ตรวจสอบกับกล้องวงจรปิดแล้ว",
    window: "ช่วงเวลา {from}–{to}",
    alreadyHeading: "ปิดยอดแล้ว",
    signedAt: "ปิดยอดเมื่อ {when}",
    signedBy: "โดย {staff}",
    verdictAtSignoffLabel: "ผลกระทบยอด ณ วันที่ปิดยอด",
    verdictUnknown: "ไม่มีการบันทึกไว้ในภาพรวมนี้",
    submitting: "กำลังปิดยอด…",
    errorAlreadySigned: "วันทำการนี้ปิดยอดไปแล้ว",
    errorNotOver: "วันทำการนี้ยังไม่สิ้นสุด",
    errorScope: "คาสิโนนี้ไม่ตรงกับเซสชันของคุณ กรุณารีเฟรชแล้วลองใหม่",
    errorCasinoRequired: "กรุณาเลือกคาสิโนก่อนปิดยอด",
    errorInactive: "คาสิโนหรือบัญชีพนักงานนี้ถูกระงับการใช้งาน",
    errorUpstream: "ไม่สามารถเชื่อมต่อกับระบบกระทบยอดได้ กรุณาลองใหม่",
    errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
    errorBuddhistYear: "ปี {year} ดูเหมือนเป็นปีพุทธศักราช ช่องนี้ต้องการปีคริสต์ศักราช (ค.ศ.) คือ {ceYear}",
    errorInvalidDate: "กรอกวันทำการที่ถูกต้อง",
    confirmUnavailable: "ไม่สามารถปิดยอดได้ขณะนี้",
    casino: "คาสิโน",
    delta: {
      heading: "มีการเปลี่ยนแปลงตั้งแต่ปิดยอด",
      noChange: "ไม่มีการเปลี่ยนแปลงตั้งแต่ปิดยอด",
      cannotCompare: "ไม่สามารถเทียบกับภาพรวมที่ปิดยอดไว้ได้ — รูปแบบรายงานเปลี่ยนไปตั้งแต่ปิดยอด",
    },
    stepUp: {
      password: "รหัสผ่านของคุณ",
      errorPasswordRequired: "กรอกรหัสผ่านของคุณเพื่อยืนยัน",
      errorInvalidPassword: "รหัสผ่านไม่ถูกต้อง",
      errorStepUpRequired: "การดำเนินการนี้ต้องยืนยันรหัสผ่านอีกครั้ง กรุณากรอกรหัสผ่านแล้วลองใหม่",
      errorRateLimited: "ถูกล็อกอีก {minutes} นาที ไม่ใช่ปัญหาจากรหัสผ่าน",
      errorGeneric: "ไม่สามารถตรวจสอบรหัสผ่านได้ กรุณาลองใหม่",
      verifying: "กำลังตรวจสอบรหัสผ่าน…",
    },
  },
  breakglass: {
    acting: "กำลังทำงานที่ {casino}",
    recorded: "สิทธิ์ platform_admin ทุกการกระทำถูกบันทึกในชื่อคุณ",
    leave: "ออกจาก {casino}",
  },
  empty: {
    operations: "ไม่มีรายการวันนี้",
    operationsBody: "อนุมัติรายการเมื่อต้องเข้าดูแลเครื่อง",
    exceptions: "ไม่มีรายการค้างดำเนินการ",
    exceptionsBody: "รายการผิดปกติของการจ่ายเงินและรายการเงินสดค้างทุกรายการได้รับการแก้ไขแล้ว",
  },
  error: { rateLimited: "ถูกล็อกอีก {minutes} นาที ไม่ใช่ปัญหาจากรหัสผ่าน" },
  auth: {
    title: "เข้าสู่ระบบ",
    brandTagline: "จัดการเงินสดตู้คีออส",
    thesisHeadlineLead: "ทุกบาท",
    thesisHeadlineEm: "ต้องตรง",
    thesisBody: "นับจากเครื่อง เทียบกับกระเป๋าเงิน แล้วปิดยอดวันทำการอย่างมั่นใจ",
    thesisPoint1: "ทุกรายการเงินสดถูกเทียบสองทาง",
    thesisPoint2: "ปิดยอดวันทำการได้ก็ต่อเมื่อยอดตรง หรือยืนยันผลต่างแล้วเท่านั้น",
    thesisPoint3: "ทุกการกระทำถูกบันทึกลงสมุดตรวจสอบ พร้อมชื่อผู้ทำและเวลา",
    audited: "ทุกการเข้าสู่ระบบถูกบันทึกลงสมุดตรวจสอบ",
    username: "ชื่อผู้ใช้",
    password: "รหัสผ่าน",
    casinoId: "พาร์ทิชันคาสิโน",
    casinoIdHint: "พาร์ทิชันที่จะเข้าสู่ระบบ เว้นว่างไว้เพื่อเข้าสู่ระบบในพาร์ทิชันของ platform_admin",
    submit: "เข้าสู่ระบบ",
    submitting: "กำลังเข้าสู่ระบบ…",
    invalidCredentials: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
    genericError: "เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่",
    signedIn: "เข้าสู่ระบบในชื่อ {username} พื้นที่ทำงาน: {workspace}",
    idleLocked: "ล็อกแล้วเนื่องจากไม่มีการใช้งานนาน 15 นาที กรุณาเข้าสู่ระบบอีกครั้งเพื่อทำงานต่อจากเดิม",
    sessionExpired: "เซสชันของคุณสิ้นสุดลงแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
  },
  workspace: {
    kiosks: "ตู้คีออส",
    cage: "แคชเชียร์",
    day: "วันทำการ",
    tenancy: "การดูแลระบบ",
    activity: "บันทึกกิจกรรม",
  },
  role: {
    // Human labels for chrome only. The API's role strings stay untranslated wherever they are
    // identifiers — `platform_admin` is quoted to support and grepped in logs.
    platform_admin: "ผู้ดูแลระบบแพลตฟอร์ม",
    manager: "ผู้จัดการ",
    technician: "ช่างเทคนิค",
    cashier: "แคชเชียร์",
  },
  nav: { back: "ย้อนกลับ" },
  shell: {
    title: "Kiosk Console",
    workspaces: "พื้นที่ทำงาน",
    signOut: "ออกจากระบบ",
    menu: "เมนู",
    language: "ภาษา",
    en: "English",
    th: "ไทย",
    allCasinos: "ทุกคาสิโน",
    skipToContent: "ข้ามไปยังเนื้อหา",
  },
  kiosks: {
    heading: "ตู้คีออส",
    needBreakGlass: "เข้าสู่คาสิโนจากเมนูการดูแลระบบเพื่อดูตู้คีออส",
    retired: "ปลดระวางแล้ว",
    neverSeen: "ไม่เคยส่งสัญญาณ",
    healthy: "ไม่ต้องดำเนินการ",
    allKiosksHeading: "ตู้คีออสทั้งหมด",
    operationsFor: "รายการดำเนินการ — {kiosk}",
    newOperation: "รายการใหม่",
    newOperationOnlyTechnician: "เฉพาะช่างเทคนิคเท่านั้นที่อนุมัติรายการใหม่ได้",
    retiredReason: "ตู้คีออสนี้ปลดระวางแล้ว ไม่สามารถเปิดรายการใหม่หรือออกรหัสเปิดใช้งานได้",
    operationsErrorGeneric: "ไม่สามารถโหลดรายการดำเนินการได้ รายการนี้อาจไม่ครบถ้วน — กรุณาลองใหม่",
    authorize: {
      title: "อนุมัติรายการ — {kiosk}",
      kind: "ประเภท",
      declarationHint: "นับธนบัตรที่จะเติม ยอดรวมคำนวณให้อัตโนมัติ ไม่ต้องพิมพ์เอง",
      submit: "อนุมัติ",
      submitting: "กำลังอนุมัติ…",
      cancel: "ยกเลิก",
      errorDenomination: "ธนบัตรชนิดนี้ไม่สามารถเป็นเงินทอนได้",
      errorRetired: "ตู้คีออสนี้ปลดระวางแล้ว ไม่สามารถเปิดรายการใหม่ได้",
      errorNotFound: "ไม่พบตู้คีออสนี้",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
    },
    operation: {
      expired: "หมดอายุแล้ว — ตู้คีออสจะไม่รับรายการนี้อีก",
      cancel: "ถอนการอนุมัติ",
      cancelling: "กำลังถอน…",
      cancelOnlyTechnician: "เฉพาะช่างเทคนิคผู้อนุมัติเท่านั้นที่ถอนรายการนี้ได้",
      errorNotCancellable: "ตู้คีออสรับรายการนี้ไปแล้ว ไม่สามารถถอนได้อีก",
      close: "ปิดรายการ",
      closeOnlyManager: "เฉพาะผู้จัดการเท่านั้นที่ปิดรายการค้างได้",
      closeFromDay: "ปิดรายการค้างได้จากพื้นที่ทำงานวันทำการ",
    },
    activation: {
      button: "ออกรหัสเปิดใช้งาน",
      title: "ออกรหัสเปิดใช้งาน — {kiosk}",
      body: "การดำเนินการนี้จะสร้างรหัสเปิดใช้งานสำหรับตู้คีออสนี้ ตู้ใช้รหัสเดิมซ้ำได้ทุกครั้งที่เปิดเครื่อง จนกว่าจะออกรหัสใหม่ (รหัสเดิมใช้ไม่ได้ทันที) หรือเพิกถอนสิทธิ์เชื่อมต่อ รหัสจะแสดงเพียงครั้งเดียวและถูกจัดเก็บแบบแฮช หากรหัสหาย ต้องออกรหัสใหม่",
      issue: "ออกรหัส",
      issuing: "กำลังออกรหัส…",
      cancel: "ยกเลิก",
      confirm: "ฉันจดไว้แล้ว",
      acknowledge: "ฉันได้จดรหัสนี้ไว้แล้ว และจะไม่แสดงอีก",
      expires: "ต้องใช้ครั้งแรกก่อน {when} — หลังจากนั้นใช้ซ้ำได้จนกว่าจะออกรหัสใหม่หรือเพิกถอน",
      retired: "ตู้คีออสนี้ปลดระวางแล้ว ไม่สามารถเปิดใช้งานได้",
      dismiss: "ปิดโดยไม่ยืนยัน",
      dismissConfirm: "ยืนยัน ปิดโดยไม่ยืนยันว่าจดแล้ว",
      dismissWarning: "รหัสนี้จะไม่แสดงอีก กดอีกครั้งเพื่อปิดโดยไม่ยืนยันว่าได้จดรหัสไว้แล้ว",
    },
    revoke: {
      button: "เพิกถอนสิทธิ์เชื่อมต่อ",
      onlyManager: "เฉพาะผู้จัดการเท่านั้นที่เพิกถอนสิทธิ์เชื่อมต่อของตู้คีออสได้",
      credentialUnavailable: "ยังไม่มีรหัสสิทธิ์เชื่อมต่อของตู้คีออสนี้",
      title: "เพิกถอนสิทธิ์เชื่อมต่อของตู้คีออสนี้ — {kiosk}",
      confirm: "เพิกถอนสิทธิ์เชื่อมต่อของ {kiosk}",
      cancel: "ยกเลิก",
      consequence:
        "การดำเนินการนี้จะทำให้ {kiosk} ไม่สามารถเริ่มรอบเล่นใหม่หรือเคลื่อนย้ายเงินสดได้ทันที ต้องออกรหัสเปิดใช้งานใหม่เพื่อเปิดใช้งานอีกครั้ง",
      revoking: "กำลังเพิกถอน…",
      errorNotFound: "สิทธิ์เชื่อมต่อนี้ถูกเพิกถอนไปแล้ว ไม่มีอะไรให้เพิกถอนเพิ่มเติม",
      errorUpstream: "ไม่สามารถเชื่อมต่อบริการอุปกรณ์ได้ กรุณาลองใหม่",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      success: "เพิกถอนสิทธิ์เชื่อมต่อเรียบร้อยแล้ว",
    },
    register: {
      trigger: "ลงทะเบียนตู้คีออส",
      onlyManager: "เฉพาะผู้จัดการเท่านั้นที่ลงทะเบียนตู้คีออสใหม่ได้",
      title: "ลงทะเบียนตู้คีออส",
      kioskId: "รหัสตู้คีออส",
      kioskIdHint: "ใช้ได้เฉพาะตัวอักษร ตัวเลข ขีดล่าง และขีดกลาง — คือรหัสที่ติดอยู่บนตัวเครื่อง",
      label: "ป้ายชื่อ",
      labelHint: 'ชื่อที่จะแสดงในรายการตู้คีออส เช่น "ชั้น 2 ฝั่งตะวันตก"',
      submit: "ตรวจทานการลงทะเบียน",
      cancel: "ยกเลิก",
      confirmTitle: "ลงทะเบียนตู้คีออส — {kiosk}",
      confirmLabel: "ลงทะเบียน {kiosk}",
      consequence:
        "การดำเนินการนี้จะสร้างแถวตู้คีออสที่การเปิดใช้งาน สิทธิ์เชื่อมต่อ และโทเคนอุปกรณ์ในภายหลังทั้งหมดผูกไว้ด้วย ตู้คีออสนี้จะรับรายการเงินสดไม่ได้จนกว่าช่างเทคนิคจะเปิดใช้งาน",
      registering: "กำลังลงทะเบียน…",
      errorAlreadyExists: "มีตู้คีออสที่ใช้รหัสนี้ลงทะเบียนไว้แล้ว",
      errorInvalidId: "รหัสตู้คีออสใช้ได้เฉพาะตัวอักษร ตัวเลข ขีดล่าง และขีดกลางเท่านั้น",
      errorCasinoRequired: "เลือกคาสิโนก่อนลงทะเบียนตู้คีออส",
      errorUpstream: "ไม่สามารถเชื่อมต่อบริการตู้คีออสได้ กรุณาลองใหม่",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      successTitle: "ลงทะเบียนตู้คีออสสำเร็จ — {kiosk}",
      successBody: "ตู้คีออสนี้มีอยู่แล้วแต่ยังจับคู่กับเครื่องจริงไม่ได้จนกว่าจะมีรหัสเปิดใช้งาน",
      done: "เสร็จสิ้น",
    },
    tile: {
      neverSeen: "ไม่เคยเชื่อมต่อ",
      neverSeenBody: "ลงทะเบียนแล้วแต่ยังไม่เคยรายงานเลย",
      stale: "ไม่ได้เชื่อมต่อเมื่อเร็ว ๆ นี้",
      noCredential: "ไม่มีข้อมูลรับรองที่ใช้งานอยู่",
      retired: "ปลดระวางแล้ว",
    },
    table: { kiosk: "ตู้คีออส", status: "สถานะ", health: "สภาพการเชื่อมต่อ" },
    fleet: { reporting: "เชื่อมต่ออยู่ {n} จาก {total}" },
  },
  cage: {
    heading: "แคชเชียร์",
    needBreakGlass: "เข้าสู่คาสิโนจากเมนูการดูแลระบบเพื่อถอนเงินที่เคาน์เตอร์",
    withdrawal: {
      heading: "ถอนเงิน",
      playerId: "รหัสผู้เล่น",
      amount: "จำนวนเงิน (บาท)",
      note: "หมายเหตุ (ถ้ามี)",
      submit: "ตรวจสอบรายการถอนเงิน",
      stepsLabel: "ขั้นตอนการถอนเงิน",
      step1: "กรอกรายการ",
      step2: "ตรวจสอบ",
      step3: "จ่ายเงิน",
      quickAmountsLabel: "จำนวนที่ใช้บ่อย",
      toDispense: "จำนวนที่จะจ่าย",
      confirmTitle: "ถอนเงิน {amount} — {player}",
      consequence: "ระบบจะหักเงินจากกระเป๋าเงินและมอบธนบัตรให้ผู้เล่น",
      confirmLabel: "ถอนเงิน {amount}",
      cancel: "ยกเลิก",
      submitting: "กำลังถอนเงิน…",
      newWithdrawal: "รายการถอนเงินใหม่",
      walletRef: "หมายเลขอ้างอิงกระเป๋าเงิน",
      resultPending: "กำลังดำเนินการ",
      resultPosted: "จ่ายเงินแล้ว มอบธนบัตรให้ผู้เล่น",
      resultRefused: "กระเป๋าเงินปฏิเสธรายการถอนเงินนี้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      // `docs/TH-REVIEW.md` §2's own suggested wording, minus "ด้านล่าง": the list is no longer
      // below — it is at `/cage/exceptions` — and "รายการค้าง" named a heading that never existed,
      // while colliding with this app's word for stranded kiosk operations.
      resultUnresolved:
        "ไม่สามารถยืนยันผลลัพธ์ได้ ห้ามทำรายการซ้ำ — รายการนี้จะปรากฏในรายการผิดปกติของการจ่ายเงินเพื่อติดตามต่อ",
      resultClosed: "ปิดรายการโดยไม่มีการบันทึกกระเป๋าเงิน",
      errorEventMismatch: "หมายเลขอ้างอิงรายการนี้ถูกใช้กับจำนวนเงินหรือผู้เล่นอื่นแล้ว กรุณาเริ่มรายการถอนเงินใหม่",
      errorConflict: "หมายเลขอ้างอิงนี้ถูกใช้ที่อื่นแล้ว กรุณาเริ่มรายการถอนเงินใหม่",
      errorRace: "มีการบันทึกผลลัพธ์ของรายการนี้ไปแล้วจากการทำรายการอื่น กรุณาส่งรายการอีกครั้งเพื่อดูสถานะปัจจุบัน",
      errorScopeMismatch: "คาสิโนนี้ไม่ตรงกับเซสชันของคุณ กรุณารีเฟรชแล้วลองใหม่",
      errorInactive: "คาสิโนหรือบัญชีพนักงานนี้ถูกระงับการใช้งาน",
      errorUpstream: "ไม่สามารถเชื่อมต่อกับระบบกระเป๋าเงินได้ กรุณาลองใหม่",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      errorInDoubt:
        "ไม่ได้รับคำตอบสำหรับรายการถอนเงิน {amount} ของ {player} กระเป๋าเงินอาจหักเงินไปแล้ว — ยังไม่ต้องมอบธนบัตร",
      inDoubt:
        "การลองใหม่จะส่งรายการถอนเงิน {amount} ของ {player} เดิมด้วยหมายเลขอ้างอิงเดิม ผู้เล่นจึงไม่ถูกหักเงินซ้ำ รายละเอียดจะถูกล็อกไว้จนกว่าจะได้รับคำตอบ",
      retrySame: "ลองรายการถอนเงินนี้อีกครั้ง",
      setAside: "พักรายการนี้ไว้",
      setAsideHint:
        "ใช้เฉพาะเมื่อผู้เล่นออกไปแล้ว จดหมายเลขอ้างอิง {eventId} และแจ้งผู้จัดการ — รายการถอนเงินนี้อาจหักเงินผู้เล่นไปแล้ว",
      replayed:
        "จ่ายไปแล้ว — หมายเลขอ้างอิงนี้ดำเนินการสำเร็จตั้งแต่ครั้งก่อน คำขอนี้จึงไม่มีการเคลื่อนไหวของเงิน ห้ามมอบธนบัตรซ้ำ เว้นแต่ครั้งแรกยังไม่ได้มอบ",
    },
    exceptions: {
      heading: "รายการผิดปกติของการจ่ายเงิน",
      subheading: "ค้างอยู่ทุกวัน — ไม่กรองตามวันที่ เพราะรายการที่ยังไม่แก้ไขจะค้างอยู่เสมอ",
      errorGeneric: "ไม่สามารถโหลดรายการผิดปกติได้ รายการนี้อาจไม่ครบถ้วน — กรุณาลองใหม่",
      stuckHeading: "รายการเงินสดค้างดำเนินการ",
      kiosk: "ตู้คีออส {id}",
      cage: "เคาน์เตอร์แคชเชียร์",
      authorized: "อนุมัติไว้",
      dispensed: "จ่ายจริง",
      reasonUnknownDispense: "ไม่ทราบจำนวนที่จ่ายจริง — นับเงินในตลับ",
      reasonRefundUnresolved: "การคืนเงินยังไม่ยืนยัน — ตรวจสอบบันทึกของผู้ให้บริการ",
      reasonDebitUnresolved: "การหักเงินยังไม่ยืนยัน — ตรวจสอบบันทึกการหักเงินของผู้ให้บริการ",
      reasonUnknown: "ยังไม่ทราบสาเหตุ",
      cageWithdrawalKind: "รายการถอนเงินที่เคาน์เตอร์",
      exceptionResolutionKind: "รายการแก้ไขข้อผิดพลาด",
      loadMoreError: "โหลดหน้าถัดไปไม่สำเร็จ รายการด้านบนยังเป็นข้อมูลล่าสุด",
      retry: "ลองอีกครั้ง",
      loadMore: "โหลดเพิ่มเติม",
    },
    // Unreviewed by a Thai speaker — recorded in `docs/TH-REVIEW.md`. "ค้าง" is deliberately
    // avoided here: this file already uses it for stranded kiosk operations, and §2 of that review
    // is about exactly that collision on this screen.
    tile: {
      exceptions: "รายการผิดปกติที่ยังไม่แก้ไข",
      exceptionsBody: "ไม่กรองตามวันที่ — แต่ละรายการมีผู้เล่นรอคำตอบอยู่",
      exceptionsError: "ไม่สามารถนับจำนวนรายการผิดปกติได้ เปิดรายการเพื่อตรวจสอบ",
      atLeast: "{n}+",
    },
  },
  day: {
    heading: "วันทำการ",
    dateLabel: "วันที่ทำการ",
    needBreakGlass: "เข้าสู่คาสิโนจากเมนูการดูแลระบบเพื่อดูรายงานกระทบยอด",
    errorGeneric: "ไม่สามารถโหลดรายงานกระทบยอดได้ กรุณาลองใหม่",
    loading: "กำลังโหลด…",
    tile: {
      kiosks: "ตู้ที่ยอดไม่ตรง",
      kiosksOf: "จาก {total} ตู้บนพื้นที่",
      unresolved: "ยังไม่ได้ข้อสรุป",
      unresolvedBody: "ไม่ทราบผลลัพธ์ และจะไม่คลี่คลายเอง",
      exceptions: "รายการจ่ายที่มีปัญหา",
      stuck: "รายการที่ค้าง",
      unattributed: "รายการที่ไม่มีผู้รับผิดชอบ",
      unattributedBody: "ถูกสร้างโดยไม่มีการอนุมัติรองรับ",
      adjustments: "รายการปรับยอดกระเป๋าเงิน",
      cage: "ห้องนับเงิน",
      signoff: "ปิดยอด",
      signoffDone: "ปิดยอดแล้ว",
      signoffOpen: "ยังไม่ได้ปิดยอด",
    },
    clear: {
      kiosks: "ตู้ทั้ง {n} ตู้ยอดตรง",
      cage: "ห้องนับเงินยอดตรง",
    },
    verdict: {
      dayHint: "ยอดเงินสดที่รับเทียบกับเครดิตที่ออก รวมถึงเคาน์เตอร์แคชเชียร์",
    },
    recon: {
      cashIn: "เงินเข้า",
      cashOut: "เงินออก",
      deviceCredited: "เครดิตจากตู้",
      walletSucceeded: "ลงกระเป๋าเงิน",
      deviceDispensed: "จ่ายจากตู้",
      walletDebited: "หักกระเป๋าเงิน",
      deltaLabel: "ผลต่าง",
      balanced: "ตรง",
      off: "ต่าง",
    },
    queue: {
      heading: "รายการที่ต้องดำเนินการ",
      summary: "ต้องดำเนินการ {n} รายการ",
      allBalanced: "ไม่มีรายการที่ต้องดำเนินการ",
      allBalancedBody: "ตู้คีออสทุกตู้และเคาน์เตอร์แคชเชียร์ยอดตรงกันในวันทำการนี้",
      cageSubject: "เคาน์เตอร์แคชเชียร์",
      exception: "มีรายการผิดปกติของการจ่ายเงิน {amount}",
      unresolved: "ยอด {amount} ยังไม่ทราบผลในฝั่งใดฝั่งหนึ่ง",
      adjustments: "มีรายการปรับปรุงกระเป๋าเงินที่ตรงกับตู้นี้ {n} รายการ",
      pending: "ยังอยู่ระหว่างดำเนินการ — มียอดค้างอยู่ฝั่งใดฝั่งหนึ่ง",
      discrepant: "ยอดเงินสดที่รับและเครดิตที่ออกไม่ตรงกัน",
    },
    table: {
      heading: "ตู้คีออสทั้งหมด",
      kiosk: "ตู้คีออส {id}",
      viewDrilldown: "ดูรายละเอียดทีละรายการ",
      selectPrompt: "เลือกตู้คีออสด้านบนเพื่อดูรายละเอียดทีละรายการ",
    },
    operations: {
      heading: "รายการดำเนินการ",
      hint: "การเติมเงินทอน การถ่ายเงิน การปิดตู้ และการกระทบยอด — เป็นคนละคำถามจากยอดเงินสดที่รับเทียบกับเครดิตที่ออกด้านบน",
      unattributed: "ไม่ทราบผู้อนุมัติ {n} รายการ — อนุมัติผ่านรหัส PIN ฉุกเฉิน ไม่ใช่พนักงานที่เข้าสู่ระบบ",
      discrepantHeading: "รายการดำเนินการที่ไม่ตรงกัน",
      discrepantEmpty: "ไม่มีรายการที่ไม่ตรงกัน",
      discrepantEmptyBody: "ยอดสำแดงและยอดที่ได้รับของทุกรายการตรงกัน",
      stuckHeading: "รายการดำเนินการค้าง",
      stuckHint: "ค้างอยู่ทุกวัน — ไม่กรองตามวันทำการด้านบน",
      stuckEmpty: "ไม่มีรายการค้าง",
      stuckEmptyBody: "ไม่มีรายการใดรอผู้จัดการปิดยอด",
      stuckSince: "ค้างมาตั้งแต่ {when}",
      expires: "หมดอายุ {when}",
      noExpiry: "ไม่มีวันหมดอายุ",
      close: "ปิดรายการ",
      closeOnlyManager: "เฉพาะผู้จัดการเท่านั้นที่ปิดรายการค้างได้",
      noteLabel: "พบอะไรบ้าง?",
      notePlaceholder: "เช่น นับเงินในตลับแล้ว ยืนยันเครื่องติดขัด",
      knowsAmount: "ฉันนับธนบัตรแล้วและทราบจำนวนเงิน",
      amountLabel: "จำนวนเงินที่นับได้ (บาท)",
      review: "ตรวจสอบ",
      closeCancel: "ยกเลิก",
      closeTitle: "ปิด {kind} — ตู้คีออส {kiosk}",
      closeLabel: "ปิดรายการ — ตู้คีออส {kiosk}",
      closeConsequence: "รายการนี้จะถูกบันทึกเป็น closed_by_staff และไม่มีช่องทางเปิดกลับ",
      closing: "กำลังปิดรายการ…",
      closeErrorNotCloseable: "ตู้คีออสอาจยังรับรายการนี้ได้อยู่ — ยังไม่สามารถปิดได้",
      closeErrorScope: "คาสิโนนี้ไม่ตรงกับเซสชันของคุณ กรุณารีเฟรชแล้วลองใหม่",
      closeErrorCasinoRequired: "กรุณาเลือกคาสิโนก่อนปิดรายการนี้",
      closeErrorMismatch: "จำนวนเงินที่แจ้งไม่ตรงกับยอดธนบัตร กรุณาตรวจสอบตัวเลข",
      closeErrorInactive: "คาสิโนหรือบัญชีพนักงานนี้ถูกระงับการใช้งาน",
      closeErrorUpstream: "ไม่สามารถเชื่อมต่อกับระบบตู้คีออสได้ กรุณาลองใหม่",
      closeErrorGeneric: "ไม่สามารถปิดรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
    },
    drilldown: {
      heading: "ตู้คีออส {kiosk} — รายละเอียดทีละรายการ",
      empty: "ไม่มีความเคลื่อนไหวของเงินสด",
      emptyBody: "ตู้คีออสนี้ไม่มีรายการรับเงินสดหรือรายการจ่ายเงินในวันทำการนี้",
      cashEventsHeading: "รายการรับเงินสด",
      payoutIntentsHeading: "รายการจ่ายเงิน",
      device: "เครื่อง",
      wallet: "กระเป๋าเงิน",
      notLanded: "ยังไม่เข้าระบบ",
      duplicate: "รายการซ้ำ",
      authorized: "อนุมัติไว้",
      dispensed: "จ่ายจริง",
      debit: "หักเงิน",
      refund: "คืนเงิน",
    },
  },
  // Payout-exception resolution on the manager's `/day` workspace — a new, clearly-scoped block
  // (not interleaved into `day.*` above) so a concurrent Thai QA pass on the main checkout's
  // `th.ts` merges cleanly against this branch.
  dayExceptions: {
    heading: "รายการผิดปกติของการจ่ายเงิน",
    hint: "ค้างอยู่ทุกวัน — ไม่กรองตามวันทำการด้านบน เพราะรายการที่ยังไม่แก้ไขจะค้างอยู่เสมอ",
    errorGeneric: "ไม่สามารถโหลดรายการผิดปกติได้ รายการนี้อาจไม่ครบถ้วน — กรุณาลองใหม่",
    empty: "ไม่มีรายการผิดปกติที่ค้างอยู่",
    emptyBody: "รายการผิดปกติของการจ่ายเงินทุกรายการได้รับการแก้ไขแล้ว",
    kiosk: "ตู้คีออส {id}",
    cage: "เคาน์เตอร์แคชเชียร์",
    authorized: "อนุมัติไว้",
    dispensed: "จ่ายจริง",
    creditLabel: "เครดิตเข้ากระเป๋าเงินผู้เล่น",
    playerId: "ผู้เล่น",
    reasonUnknownDispense: "ไม่ทราบจำนวนที่จ่ายจริง — นับเงินในตลับ",
    reasonRefundUnresolved: "การคืนเงินยังไม่ยืนยัน — ตรวจสอบบันทึกของผู้ให้บริการ",
    reasonDebitUnresolved: "การหักเงินยังไม่ยืนยัน — ตรวจสอบบันทึกการหักเงินของผู้ให้บริการ",
    reasonUnknown: "ยังไม่ทราบสาเหตุ",
    reasonUnknownCannotResolve: "รายการนี้ไม่มีสาเหตุบันทึกไว้ จึงไม่สามารถแก้ไขได้จากหน้านี้",
    loadMoreError: "โหลดหน้าถัดไปไม่สำเร็จ รายการด้านบนยังเป็นข้อมูลล่าสุด",
    retry: "ลองอีกครั้ง",
    loadMore: "โหลดเพิ่มเติม",
    resolve: "แก้ไขรายการ",
    resolveOnlyManager: "เฉพาะผู้จัดการเท่านั้นที่แก้ไขรายการผิดปกติของการจ่ายเงินได้",
    review: "ตรวจสอบ",
    cancel: "ยกเลิก",
    noteLabel: "พบอะไรบ้าง?",
    notePlaceholder: "เช่น นับเงินในตลับแล้ว ตรงกับยอดที่อนุมัติไว้",
    attestedDispensedLabel: "จำนวนที่นับได้ในตลับ (บาท)",
    attestedDispensedHint: "ระหว่าง ฿0 ถึง {amount}",
    attestedDispensedRequired: "กรอกจำนวนที่นับได้ในตลับ",
    attestedDispensedOutOfRange: "กรอกจำนวนเต็มระหว่าง ฿0 ถึงยอดที่อนุมัติไว้ — ระบบจะไม่ปัดตัวเลขให้",
    originalRefundLandedLabel: "บันทึกของผู้ให้บริการแสดงว่าการคืนเงินครั้งแรกสำเร็จหรือไม่?",
    originalRefundLandedYes: "ใช่ สำเร็จแล้ว",
    originalRefundLandedNo: "ไม่ ยังไม่สำเร็จ",
    originalDebitLandedLabel: "ผู้ให้บริการมีบันทึกการหักเงิน {amount} สำหรับรายการถอนนี้หรือไม่?",
    originalDebitLandedYes: "มี — ผู้ให้บริการแสดงการหักเงินนี้",
    originalDebitLandedNo: "ไม่มี — ผู้ให้บริการไม่แสดงการหักเงินนี้",
    confirmTitle: "แก้ไขรายการผิดปกติ — ตู้คีออส {kiosk}",
    confirmLabel: "แก้ไขรายการ — {player}",
    consequence:
      "ระบบจะเครดิตเงินเข้ากระเป๋าเงินเท่ากับยอดที่อนุมัติลบด้วยจำนวนที่ท่านยืนยัน และไม่สามารถย้อนกลับได้จากหน้านี้",
    consequenceDebitLanded:
      "ผู้เล่นถูกหักเงินแต่ไม่ได้รับธนบัตร ระบบจะเครดิตเงินคืนเข้ากระเป๋าเงินผู้เล่นเต็มจำนวน และไม่สามารถย้อนกลับได้จากหน้านี้",
    consequenceDebitNotLanded:
      "ไม่มีเงินเคลื่อนไหว ระบบจะปิดรายการผิดปกตินี้โดยไม่บันทึกรายการใดในกระเป๋าเงินผู้เล่น และไม่สามารถย้อนกลับได้จากหน้านี้",
    confirmPhraseInstruction:
      "พิมพ์จำนวนเครดิตเป็นตัวเลขล้วน — ไม่ใส่สัญลักษณ์ ฿ ไม่ใส่เครื่องหมายจุลภาค — เพื่อยืนยัน",
    submitting: "กำลังแก้ไขรายการ…",
    dismiss: "ปิด",
    resultPending: "กำลังดำเนินการ",
    resultPosted: "แก้ไขรายการสำเร็จ เครดิตเข้าระบบแล้ว",
    resultRefused: "กระเป๋าเงินปฏิเสธการแก้ไขรายการนี้ ตรวจสอบรายละเอียดแล้วลองใหม่",
    resultUnresolved:
      "ไม่สามารถยืนยันผลลัพธ์ได้ ห้ามทำรายการซ้ำ — รายการนี้จะปรากฏในรายการเงินสดค้างด้านล่างเพื่อติดตามต่อ",
    resultClosed: "ปิดรายการโดยไม่มีการบันทึกกระเป๋าเงิน",
    errorOutOfRange: "จำนวนที่นับได้อยู่นอกช่วงที่อนุมัติไว้ ตรวจสอบตัวเลขแล้วลองใหม่",
    errorAttestationShape: "การยืนยันนี้ไม่ตรงกับสาเหตุของรายการ กรุณารีเฟรชแล้วลองใหม่",
    errorReasonUnknown: "รายการนี้ไม่มีสาเหตุบันทึกไว้ จึงไม่สามารถแก้ไขได้จากหน้านี้",
    errorNotFound: "ไม่พบรายการผิดปกตินี้ อาจได้รับการแก้ไขไปแล้ว",
    errorScope: "คาสิโนนี้ไม่ตรงกับเซสชันของคุณ กรุณารีเฟรชแล้วลองใหม่",
    errorCasinoRequired: "กรุณาเลือกคาสิโนก่อนแก้ไขรายการนี้",
    errorRace: "มีการบันทึกผลลัพธ์ของรายการนี้ไปแล้วจากการทำรายการอื่น กรุณารีเฟรชเพื่อดูสถานะปัจจุบัน",
    errorPayoutNotDebited:
      "รายการจ่ายเงินนี้ไม่มีการหักเงินที่สำเร็จในระบบ จึงไม่มีอะไรให้ชดเชย การส่งซ้ำจะไม่เปลี่ยนผลลัพธ์นี้ — ตรวจสอบรายการหักเงินก่อนลองใหม่",
    errorRefundAlreadySucceeded:
      "การคืนเงินของรายการจ่ายนี้สำเร็จไปแล้ว การเครดิตซ้ำจะทำให้ผู้เล่นได้รับเงินสองครั้ง จึงไม่สามารถส่งรายการนี้ได้ — รีเฟรชรายการก่อนดำเนินการต่อ",
    errorRefundNotUnresolved:
      "การคืนเงินที่เกี่ยวข้องไม่ได้อยู่ในสถานะยังไม่ยืนยันอีกต่อไป — สถานะเปลี่ยนไปตั้งแต่โหลดรายการนี้ กรุณารีเฟรชรายการแทนการส่งซ้ำ เพราะข้อมูลนี้ล้าสมัยแล้ว",
    errorDebitNotUnresolved:
      "กระเป๋าเงินไม่ได้บันทึกการหักเงินของรายการนี้ว่ายังไม่ยืนยันอีกต่อไป — สถานะเปลี่ยนไปตั้งแต่โหลดรายการนี้ กรุณารีเฟรชรายการแทนการส่งซ้ำ เพราะข้อมูลนี้ล้าสมัยแล้ว",
    errorCashEventMismatch:
      "รายการผิดปกตินี้ได้รับการแก้ไขไปแล้วด้วยการยืนยันที่ต่างจากที่เพิ่งส่งไป การส่งตัวเลขนี้ซ้ำจะไม่เปลี่ยนผลลัพธ์ — ตรวจสอบว่าระบบบันทึกอะไรไว้จริง",
    errorStaffCashConflict:
      "การแก้ไขรายการผิดปกตินี้ถูกจับจองไว้แล้วภายใต้คาสิโนอื่น จึงไม่สามารถแก้ไขได้จากหน้านี้ — การลองใหม่จะไม่ช่วยอะไร",
    errorRoleForbidden:
      "สิทธิ์ของบทบาทคุณไม่อนุญาตให้แก้ไขรายการผิดปกติอีกต่อไป กรุณาเข้าสู่ระบบใหม่เพื่อรีเฟรชสิทธิ์การใช้งานก่อนลองใหม่",
    errorInactive: "คาสิโนหรือบัญชีพนักงานนี้ถูกระงับการใช้งาน",
    errorUpstream: "ไม่สามารถเชื่อมต่อกับระบบกระเป๋าเงินหรือตู้คีออสได้ กรุณาลองใหม่",
    stuckHeading: "รายการเงินสดค้างดำเนินการ",
    stuckHint: "ค้างอยู่ทุกวัน — ไม่กรองตามวันทำการด้านบน",
    cageWithdrawalKind: "รายการถอนเงินที่เคาน์เตอร์",
    exceptionResolutionKind: "รายการแก้ไขข้อผิดพลาด",
  },
  dayStranded: {
    heading: "รายการจ่ายเงินที่ค้างอยู่",
    hint: "รายการจ่ายเงินที่ตู้คีออสไม่ดำเนินการต่อหลังหักเงินแล้ว — ติดตามที่ตัวเครื่อง ค้างอยู่ทุกวัน และแก้ไขจากหน้านี้ไม่ได้ เพราะตู้คีออสอาจยังรายงานผลเข้ามา",
    onlyManager: "เฉพาะผู้จัดการเท่านั้นที่ดูรายการจ่ายเงินที่ค้างอยู่ได้",
    error: "ไม่สามารถโหลดรายการจ่ายเงินที่ค้างอยู่ได้ ซึ่งไม่ได้แปลว่าไม่มีรายการค้าง",
    retry: "ลองอีกครั้ง",
    empty: "ไม่มีรายการจ่ายเงินที่ค้างอยู่",
    emptyBody: "รายการจ่ายเงินของตู้คีออสที่เก่ากว่า {minutes} นาทีดำเนินการเสร็จทั้งหมดแล้ว",
    ageAtLeast: "เกิน {minutes} นาที",
    columns: {
      kiosk: "ตู้คีออส",
      player: "ผู้เล่น",
      amount: "จำนวนเงิน",
      status: "สถานะ",
      age: "ค้างมานาน",
    },
  },
  tenancy: {
    heading: "การดูแลระบบ",
    subnav: "หมวดการดูแลระบบ",
    staffLink: "พนักงาน",
    casino: {
      heading: "คาสิโน",
      idColumn: "คาสิโน",
      statusColumn: "สถานะ",
      tenancyColumn: "อะแดปเตอร์ · เอเจนต์",
      idleColumn: "ช่วงเวลาไม่มีการใช้งาน",
      manageColumn: "จัดการ",
      edit: "แก้ไข",
      status: "สถานะ",
      adapter: "อะแดปเตอร์",
      agentCode: "รหัสตัวแทน",
      idleWindowMinutes: "ช่วงเวลาไม่มีการใช้งาน (นาที)",
      idleWindow: "ไม่มีการใช้งาน {n} นาที",
      save: "บันทึก",
      cancel: "ยกเลิก",
      tenancyWarning:
        "การเปลี่ยนอะแดปเตอร์หรือรหัสตัวแทนจะเปลี่ยนกระเป๋าเงินที่ทุกรายการของคาสิโนนี้จะไปถึง หากผิดพลาด เงินจะไปลงที่คาสิโนอื่นที่ไม่ใช่คาสิโนนี้",
      confirmTitle: "เปลี่ยนการดูแลระบบ — {casino}",
      confirmLabel: "เปลี่ยนการดูแลระบบ",
      consequence:
        "รายการกระเป๋าเงินของคาสิโนนี้จะไปยังรหัสตัวแทนด้านล่างนับจากนี้ การกระทำนี้ไม่โยกเงินเอง แต่กำหนดว่าเงินในอนาคตจะไปลงที่ใด",
      saving: "กำลังบันทึก…",
      pairFrom: "เดิม",
      pairTo: "ใหม่",
      frozenNotice:
        "คาสิโนนี้มีผู้เล่นอยู่แล้ว การเปลี่ยนแปลงนี้จะทำให้การเชื่อมโยงกระเป๋าเงินเดิมค้างถาวร — ไม่มีช่องทางย้อนกลับ",
      retryAcknowledged: "ลองใหม่ ยอมรับการค้างของการเชื่อมโยงเดิม",
      errorNotFound: "ไม่พบคาสิโนนี้",
      errorInactive: "คาสิโนนี้ถูกระงับการใช้งาน",
      errorFrozen:
        "คาสิโนนี้มีผู้เล่นอยู่แล้ว ไม่สามารถเปลี่ยนอะแดปเตอร์หรือรหัสตัวแทนได้ เว้นแต่ยอมรับว่าการเชื่อมโยงเดิมจะค้าง",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      emptyHeadline: "ยังไม่มีคาสิโน",
      emptyBody: "ใช้ปุ่มสร้างคาสิโนด้านบนเพื่อสร้างคาสิโนแรก",
      reviewing: "กำลังตรวจทานการเปลี่ยนแปลงนี้ด้านล่าง — ฟิลด์ถูกล็อกจนกว่าจะยืนยันหรือยกเลิก",
      create: {
        trigger: "สร้างคาสิโน",
        onlyAdmin: "เฉพาะผู้ดูแลระบบแพลตฟอร์มเท่านั้นที่สร้างคาสิโนได้",
        title: "สร้างคาสิโน",
        id: "รหัสคาสิโน",
        idHint: "เปลี่ยนแปลงไม่ได้หลังจากสร้างแล้ว",
        name: "ชื่อ",
        adapter: "อะแดปเตอร์",
        adapterPlaceholder: "เลือกอะแดปเตอร์",
        agentCode: "รหัสตัวแทน",
        agentCodeHint: "หนึ่งเอเจนต์ให้บริการเพียงหนึ่งคาสิโนเท่านั้น — แก้ไขได้ง่ายเฉพาะก่อนคาสิโนนี้จะมีผู้เล่น",
        idleWindowMinutes: "ช่วงเวลาไม่มีการใช้งาน (นาที, ไม่บังคับ)",
        submit: "ตรวจทานคาสิโน",
        cancel: "ยกเลิก",
        confirmTitle: "สร้างคาสิโน — {name}",
        confirmLabel: "สร้าง {name}",
        consequence:
          "คาสิโนนี้จะรับรอบเล่นได้เมื่อมีตู้คีออสลงทะเบียนไว้ อะแดปเตอร์และรหัสตัวแทนกำหนดว่ารายการกระเป๋าเงินในภายหลังของคาสิโนนี้จะไปลงที่ใด",
        creating: "กำลังสร้าง…",
        errorAlreadyExists: "มีคาสิโนที่ใช้รหัสนี้อยู่แล้ว",
        errorAgentPairBound: "คาสิโนอื่นถือคู่อะแดปเตอร์และรหัสตัวแทนนี้อยู่แล้ว",
        errorUpstream: "ไม่สามารถเชื่อมต่อบริการเล่นเกมได้ กรุณาลองใหม่",
        errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
        successTitle: "สร้างคาสิโนสำเร็จ — {name}",
        successBody: "{id} เปิดใช้งานแล้ว ลงทะเบียนตู้คีออสให้คาสิโนนี้จากพื้นที่ทำงานตู้คีออสเพื่อเริ่มรับรอบเล่น",
        done: "เสร็จสิ้น",
      },
    },
    enter: {
      heading: "เข้าสู่คาสิโน",
      currentlyActing: "กำลังทำงานที่ {casino}",
      noCasinos: "ยังไม่มีคาสิโนให้เข้า",
      pick: "คาสิโน",
      search: "ค้นหาคาสิโน — รหัส หรือ ชื่อ…",
      countOf: "{n} จาก {total} คาสิโน",
      noMatch: "ไม่พบคาสิโนที่ตรงกับ “{q}”",
      aboutToEnter: "กำลังจะเข้า",
      pickHint: "เลือกคาสิโนที่จะเข้าจากรายการด้านบน",
      enterNamed: "เข้าสู่ {casino}",
      pickFirst: "เลือกคาสิโนก่อน",
      password: "รหัสผ่านของคุณ",
      entering: "กำลังเข้าสู่ระบบ…",
      errorPasswordRequired: "กรอกรหัสผ่านของคุณเพื่อยืนยัน",
      errorInvalidPassword: "รหัสผ่านไม่ถูกต้อง",
      errorStepUpRequired: "การดำเนินการนี้ต้องยืนยันรหัสผ่านอีกครั้ง กรุณากรอกรหัสผ่านแล้วลองใหม่",
      errorRateLimited: "ถูกล็อกอีก {minutes} นาที ไม่ใช่ปัญหาจากรหัสผ่าน",
      errorGeneric: "ไม่สามารถเข้าสู่คาสิโนนี้ได้ กรุณาลองใหม่",
      errorLoadingCasinos: "ไม่สามารถโหลดรายชื่อคาสิโนได้ กรุณาลองใหม่",
    },
    staff: {
      heading: "พนักงาน",
      partition: "พาร์ทิชัน",
      platformAdminPartition: "ผู้ดูแลระบบแพลตฟอร์ม",
      statusColumn: "สถานะ",
      manageColumn: "จัดการ",
      countTotal: "ทั้งหมด {n}",
      countActive: "ใช้งาน {n}",
      countInactive: "ระงับ {n}",
      roleImmutableHint: "ไม่สามารถเปลี่ยนบทบาทของ platform_admin ได้",
      deactivate: "ระงับการใช้งาน",
      activate: "เปิดใช้งาน",
      setPassword: "ตั้งรหัสผ่าน",
      submitPassword: "ตั้งรหัสผ่าน",
      cancel: "ยกเลิก",
      createHeading: "เพิ่มพนักงาน",
      username: "ชื่อผู้ใช้",
      password: "รหัสผ่าน",
      passwordHint: "อย่างน้อย 12 ตัวอักษร",
      role: "บทบาท",
      newIsPlatformAdmin: "พาร์ทิชันนี้สร้างได้เฉพาะบัญชี platform_admin เท่านั้น",
      create: "เพิ่มพนักงาน",
      creating: "กำลังเพิ่ม…",
      errorAlreadyExists: "ชื่อผู้ใช้นี้ถูกใช้แล้วในพาร์ทิชันนี้",
      errorRoleImmutable:
        "ไม่สามารถเปลี่ยนบทบาทของ platform_admin ได้ ให้ระงับการใช้งานแล้วสร้างบัญชีที่มีขอบเขตแทน",
      errorLastAdmin: "นี่คือ platform_admin ที่ใช้งานอยู่รายสุดท้าย เปิดใช้งานผู้ดูแลคนที่สองก่อนเปลี่ยนรายนี้",
      errorNotFound: "ไม่พบพนักงานคนนี้",
      errorGeneric: "ไม่สามารถทำรายการนี้ได้ ตรวจสอบรายละเอียดแล้วลองใหม่",
      emptyHeadline: "ยังไม่มีพนักงานในพาร์ทิชันนี้",
      emptyBody: "เพิ่มพนักงานคนแรกด้านล่าง",
    },
  },
  // The `/activity` workspace. `action.*` mirrors the API's action strings verbatim as nested
  // objects; an action with no entry here renders as the raw string, never as a blank cell.
  activity: {
    heading: "บันทึกกิจกรรม",
    filters: {
      casino: "คาสิโน",
      allCasinos: "ทุกคาสิโน",
      staffId: "รหัสพนักงาน",
      action: "การกระทำ",
      allActions: "ทุกการกระทำ",
      from: "ตั้งแต่วันที่",
      to: "ถึงวันที่",
    },
    columns: {
      time: "เวลา",
      staff: "พนักงาน",
      action: "การกระทำ",
      casino: "คาสิโน",
      target: "เป้าหมาย",
    },
    platform: "ทั้งแพลตฟอร์ม",
    loadMore: "โหลดเพิ่ม",
    empty: "ไม่มีกิจกรรมที่ตรงกับตัวกรองนี้",
    emptyBody: "ขยายช่วงวันที่ หรือล้างตัวกรองด้านบน",
    error: "ไม่สามารถโหลดบันทึกกิจกรรมได้ รายการนี้อาจแสดงไม่ครบ กรุณาลองใหม่",
    action: {
      cage: {
        withdrawal: "ถอนเงินที่แคชเชียร์",
        withdrawal_requested: "ส่งคำขอถอนเงินที่แคชเชียร์",
      },
      kiosk: {
        operation: {
          authorize: "อนุมัติรายการที่ตู้คีออส",
          cancel: "ถอนการอนุมัติรายการที่ตู้คีออส",
          close: "ปิดรายการที่ค้าง",
        },
        registered: "ลงทะเบียนตู้คีออส",
      },
      activation: { issued: "ออกรหัสเปิดใช้งาน" },
      credential: { revoked: "เพิกถอนกุญแจของตู้คีออส" },
      payout_exception: {
        resolved: "แก้ไขรายการจ่ายเงินที่มีปัญหา",
        resolve_requested: "ส่งคำขอแก้ไขรายการจ่ายเงินที่มีปัญหา",
      },
      report: { signoff: "ปิดยอดวันทำการ" },
      casino: {
        created: "สร้างคาสิโน",
        updated: "แก้ไขคาสิโน",
        break_glass_enter: "เข้าสู่คาสิโนด้วยสิทธิ์ฉุกเฉิน",
      },
      staff: {
        created: "สร้างบัญชีพนักงาน",
        create_requested: "ขอสร้างบัญชีพนักงาน",
        password_reset: "ตั้งรหัสผ่านพนักงานใหม่",
      },
      session: { login: "เข้าสู่ระบบ" },
    },
  },
  /** Accessible names for landmark sections and lists — read by screen readers, never shown. */
  aria: {
    signoffStatus: "สถานะการปิดยอด",
    changedFields: "รายการที่เปลี่ยนแปลง",
    operations: "รายการปฏิบัติการเงินสด",
    discrepantOperations: "รายการปฏิบัติการที่ยอดไม่ตรง",
    strandedOperations: "รายการปฏิบัติการที่ค้างอยู่",
    strandedPayouts: "รายการจ่ายเงินที่ค้างอยู่",
    payoutExceptions: "รายการจ่ายเงินผิดปกติ",
    kioskDrilldown: "รายละเอียดตู้คีออส",
    cashEvents: "รายการเงินสด",
    payoutIntents: "รายการคำสั่งจ่ายเงิน",
    signOff: "ปิดยอด",
    casinos: "คาสิโน",
    createStaff: "สร้างบัญชีพนักงาน",
  },
} satisfies MessageSchema;

export default th;
